import { render } from "./RotatableArrowDown.vue?vue&type=template&id=8820f658&scoped=true"
import script from "./RotatableArrowDown.vue?vue&type=script&lang=js"
export * from "./RotatableArrowDown.vue?vue&type=script&lang=js"

import "./RotatableArrowDown.vue?vue&type=style&index=0&id=8820f658&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8820f658"]])

export default __exports__